define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/widget/MessageDialog",
	"./CheckSyncOrUpdateAttributes"
], function(declare,lang,action,MessageDialog,CheckSyncOrUpdateAttributes) {

	return declare(CheckSyncOrUpdateAttributes, {
		_resetOperation: "CRGReinitializeOperationCosts",
		_refreshOperation: "CRGUpdateAttributesFromCostItems",

		_promptForReset: function() {
			this.confirmAction({
				buttons: [MessageDialog.BUTTON_CANCEL, MessageDialog.BUTTON_CONTINUE, MessageDialog.BUTTON_RESET],
				message: this.getString(action.SUFFIX_PROMPT + "Reset"),
				onResponse: lang.hitch(this, this._afterPromptForReset)
			});
		}

	});
});